// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stimulus-annotation-highlight {
  padding: 0.05em 0.12em;
  border-radius: 0.22rem;
  background: rgba(250, 204, 21, 0.38);
  color: inherit;
  -webkit-text-decoration: underline dotted rgba(161, 98, 7, 0.8);
          text-decoration: underline dotted rgba(161, 98, 7, 0.8);
  text-decoration-thickness: 1px;
  text-underline-offset: 0.18em;
  cursor: help;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.stimulus-annotation-highlight:hover,
.stimulus-annotation-highlight:focus,
.stimulus-annotation-highlight.is-active {
  outline: none;
  background: rgba(250, 204, 21, 0.62);
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.22);
}

.dark .stimulus-annotation-highlight {
  background: rgba(245, 158, 11, 0.3);
  text-decoration-color: rgba(253, 230, 138, 0.78);
}

.dark .stimulus-annotation-highlight:hover,
.dark .stimulus-annotation-highlight:focus,
.dark .stimulus-annotation-highlight.is-active {
  background: rgba(245, 158, 11, 0.48);
  box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.22);
}

.stimulus-teaching-tooltip {
  position: fixed;
  z-index: 10030;
  width: min(20rem, calc(100vw - 1.5rem));
  padding: 0.8rem 0.9rem;
  border: 1px solid #f3d27a;
  border-radius: 0.65rem;
  background: #fffdf5;
  color: #374151;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.2);
  box-sizing: border-box;
  pointer-events: auto;
}

.stimulus-teaching-tooltip--above {
  transform: none;
}

.stimulus-teaching-tooltip__message {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
}

.stimulus-teaching-tooltip__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  border: 1px solid rgba(209, 213, 219, 0.95);
  border-radius: 999px;
  background: #ffffff;
}

.stimulus-teaching-tooltip__avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}

.stimulus-teaching-tooltip__message p {
  flex: 1 1;
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.48;
}

.stimulus-teaching-tooltip__example {
  display: grid;
  gap: 0.25rem;
  margin-top: 0.65rem;
  padding-top: 0.55rem;
  border-top: 1px solid rgba(217, 119, 6, 0.2);
}

.stimulus-teaching-tooltip__example span {
  color: #92400e;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.stimulus-teaching-tooltip__example q {
  font-size: 0.76rem;
  font-style: italic;
  line-height: 1.42;
}

.stimulus-teaching-tooltip__settings-hint {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.65rem;
  padding-top: 0.55rem;
  border-top: 1px solid rgba(217, 119, 6, 0.16);
  color: #78716c;
  font-size: 0.64rem;
  line-height: 1.35;
}

.stimulus-teaching-tooltip__settings-hint strong {
  color: #92400e;
  font-weight: 700;
}

.stimulus-teaching-tooltip--dark {
  border-color: rgba(245, 158, 11, 0.48);
  background: #292318;
  color: #f3f4f6;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.38);
}

.stimulus-teaching-tooltip--dark .stimulus-teaching-tooltip__example {
  border-top-color: rgba(251, 191, 36, 0.2);
}

.stimulus-teaching-tooltip--dark .stimulus-teaching-tooltip__example span {
  color: #fcd34d;
}

.stimulus-teaching-tooltip--dark .stimulus-teaching-tooltip__settings-hint {
  border-top-color: rgba(251, 191, 36, 0.14);
  color: #a8a29e;
}

.stimulus-teaching-tooltip--dark .stimulus-teaching-tooltip__settings-hint strong {
  color: #fcd34d;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/oars/StimulusAnnotationText.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,oCAAoC;EACpC,cAAc;EACd,+DAAuD;UAAvD,uDAAuD;EACvD,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;;;EAGE,aAAa;EACb,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA;;;EAGE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uCAAuC;EACvC,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;EAC7C,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".stimulus-annotation-highlight {\n  padding: 0.05em 0.12em;\n  border-radius: 0.22rem;\n  background: rgba(250, 204, 21, 0.38);\n  color: inherit;\n  text-decoration: underline dotted rgba(161, 98, 7, 0.8);\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.18em;\n  cursor: help;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.stimulus-annotation-highlight:hover,\n.stimulus-annotation-highlight:focus,\n.stimulus-annotation-highlight.is-active {\n  outline: none;\n  background: rgba(250, 204, 21, 0.62);\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.22);\n}\n\n.dark .stimulus-annotation-highlight {\n  background: rgba(245, 158, 11, 0.3);\n  text-decoration-color: rgba(253, 230, 138, 0.78);\n}\n\n.dark .stimulus-annotation-highlight:hover,\n.dark .stimulus-annotation-highlight:focus,\n.dark .stimulus-annotation-highlight.is-active {\n  background: rgba(245, 158, 11, 0.48);\n  box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.22);\n}\n\n.stimulus-teaching-tooltip {\n  position: fixed;\n  z-index: 10030;\n  width: min(20rem, calc(100vw - 1.5rem));\n  padding: 0.8rem 0.9rem;\n  border: 1px solid #f3d27a;\n  border-radius: 0.65rem;\n  background: #fffdf5;\n  color: #374151;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.2);\n  box-sizing: border-box;\n  pointer-events: auto;\n}\n\n.stimulus-teaching-tooltip--above {\n  transform: none;\n}\n\n.stimulus-teaching-tooltip__message {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n}\n\n.stimulus-teaching-tooltip__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 2rem;\n  width: 2rem;\n  height: 2rem;\n  overflow: hidden;\n  border: 1px solid rgba(209, 213, 219, 0.95);\n  border-radius: 999px;\n  background: #ffffff;\n}\n\n.stimulus-teaching-tooltip__avatar svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.stimulus-teaching-tooltip__message p {\n  flex: 1;\n  margin: 0;\n  font-size: 0.78rem;\n  line-height: 1.48;\n}\n\n.stimulus-teaching-tooltip__example {\n  display: grid;\n  gap: 0.25rem;\n  margin-top: 0.65rem;\n  padding-top: 0.55rem;\n  border-top: 1px solid rgba(217, 119, 6, 0.2);\n}\n\n.stimulus-teaching-tooltip__example span {\n  color: #92400e;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.stimulus-teaching-tooltip__example q {\n  font-size: 0.76rem;\n  font-style: italic;\n  line-height: 1.42;\n}\n\n.stimulus-teaching-tooltip__settings-hint {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-top: 0.65rem;\n  padding-top: 0.55rem;\n  border-top: 1px solid rgba(217, 119, 6, 0.16);\n  color: #78716c;\n  font-size: 0.64rem;\n  line-height: 1.35;\n}\n\n.stimulus-teaching-tooltip__settings-hint strong {\n  color: #92400e;\n  font-weight: 700;\n}\n\n.stimulus-teaching-tooltip--dark {\n  border-color: rgba(245, 158, 11, 0.48);\n  background: #292318;\n  color: #f3f4f6;\n  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.38);\n}\n\n.stimulus-teaching-tooltip--dark .stimulus-teaching-tooltip__example {\n  border-top-color: rgba(251, 191, 36, 0.2);\n}\n\n.stimulus-teaching-tooltip--dark .stimulus-teaching-tooltip__example span {\n  color: #fcd34d;\n}\n\n.stimulus-teaching-tooltip--dark .stimulus-teaching-tooltip__settings-hint {\n  border-top-color: rgba(251, 191, 36, 0.14);\n  color: #a8a29e;\n}\n\n.stimulus-teaching-tooltip--dark .stimulus-teaching-tooltip__settings-hint strong {\n  color: #fcd34d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
